import type { Components, Theme } from '@mui/material/styles';

export const globals: Pick<
  Components<Theme>,
  'MuiCssBaseline' | 'MuiInputBase'
> = {
  MuiCssBaseline: {
    styleOverrides: (theme) => ({
      // https://github.com/mui/material-ui/issues/16367#issuecomment-569829175
      '@media (prefers-reduced-motion: reduce)': {
        '*, *:before, *:after': {
          animationDuration: '0.01ms !important',
          animationIterationCount: '1 !important',
          transitionDuration: '0.01ms !important',
          scrollBehavior: 'auto !important',
        },
      },
      "[class*='Mui']": {
        //  re-include mui base line-height for all mui components while we
        // transition between fenrir v1 and fenrir v2
        lineHeight: theme.typography.body1.lineHeight,
        '> .svg-inline--fa': {
          // MUI specific recommendation for FontAwesome icons
          boxSizing: 'content-box',
          padding: 3,
          // Match base styles applied to the MUI SvgIcon component
          width: '1em',
          height: '1em',
          display: 'inline-block',
          flexShrink: 0,
        },
      },
    }),
  },
  MuiInputBase: {
    defaultProps: {
      // set default size to small to align with fenrir v1 inputs
      size: 'small',
    },
    styleOverrides: {
      root: ({ theme }) => ({
        // add background -- MUI default is a transparent background
        backgroundColor: (theme.vars || theme).palette.background.default,
      }),
    },
  },
};
